import React, { useEffect, useState } from 'react'
import axios from 'axios';

export default function Combola({ sendhargabola, indexbola, jmljam }) {
  const urlapi = process.env.REACT_APP_BASE_URL;
  const [bola, setBola] = useState([]);
  const [show, setShow] = useState(false);
  const [valbola, setValbola] = useState('');
  const [items, setItems] = useState([]);

  const getdata = async () => {
    try {
      const response = await axios.get(urlapi + "Bola");
      setBola(response.data);
    } catch (error) { }
  }

  const formatrupiah = (numb) => {
    const format = numb.toString().split("").reverse().join("");
    const convert = format.match(/\d{1,3}/g);
    const rupiah = "Rp " + convert.join(".").split("").reverse().join("");
    return rupiah;
  };

  const handlebola = (e, id, harga) => {
    const isChecked = e.target.checked;
    const storedItems = JSON.parse(localStorage.getItem("selectedItems"));
    const updatedItems = [...storedItems];
    const newItemData = {
      idbola: id,
      hargabola: harga
    };
    if (isChecked) {
      setValbola(id)
      sendhargabola(harga, true);
      updatedItems[indexbola] = {
        ...updatedItems[indexbola], // Salin data lama
        ...newItemData, // Update data baru
      };
    } else {
      setValbola('')
      sendhargabola(harga, false);
      const updatedItems = [...storedItems];
      if (updatedItems[indexbola]) {
        delete updatedItems[indexbola].hargabola;
        delete updatedItems[indexbola].idbola;
      }
    }
    localStorage.setItem("selectedItems", JSON.stringify(updatedItems));
    setItems(updatedItems);
  }

  useEffect(() => {
    getdata()
    const storedItems = localStorage.getItem("selectedItems");
    if (storedItems) {
      setItems(JSON.parse(storedItems)); // Set data ke state
    }
  }, [])
  return (
    <div>
      <div className='card mt-1'>
        <div className='card-body'>

          <div className='d-flex justify-content-between fw-bold mb-2' onClick={() => setShow(!show)}>
            <small><i className='fas fa-futbol'></i> Bola</small>
            <small>{valbola != '' ? <i className='fas fa-circle-check text-success'></i> : ''}{' '}<i className={show == false ? 'fas fa-angle-right' : 'fas fa-angle-down'}></i></small>
          </div>

          <div className={show == false ? 'd-none' : ''}>
            {bola.map((data, index) => {
              return (
                <div
                  key={index}
                  className={jmljam === 2 && indexbola !== 0 ? 'opacity-50 pe-none' : ''}
                  style={jmljam === 2 && indexbola !== 0 ? { cursor: 'not-allowed' } : {}}
                >
                  <div className='d-flex justify-content-between' key={index}>
                    <div>
                      <small style={{ color: "#2b2e5a" }} className='fw-bold'>{data.bola}</small>

                      <div><span className='badge rounded-pill bg-success'>{formatrupiah(data.harga)}</span></div>
                    </div>
                    <div>
                      <div class="form-check">
                        <img
                          src={
                            "https://ratumerak.id/adminmmsc/assets/berkas/" +
                            data.foto
                          }
                          className="img-fluid"
                          alt="Responsive image"
                          style={{ height: "40px" }}
                        ></img>
                        <input
                          class="form-check-input  border border-danger"
                          type="checkbox"
                          name="foto"
                          onChange={(e) => handlebola(e, data.id, data.harga)}
                          id="foto"
                        />
                      </div>

                    </div>
                  </div>
                  <hr />
                </div>
              )
            })}
            {bola == '' ? <><div className='text-danger text-center' style={{ fontSize: '12px' }}>Layanan bola untuk saat ini tidak dibuka{ }</div></> : <></>}
          </div>
        </div>
      </div>
    </div>
  )
}
